export default __webpack_public_path__ + "static/scribble-6f3275eaf709e8137d49bdd5b8dc82c9.png";